module.exports = __webpack_public_path__ + "img/book.55703da9.svg";